import React, {memo, useCallback} from "react";
import dayjs, { Dayjs } from 'dayjs'
import './style.css';
import {classNames} from "../../../../../../lib/classNames/classNames";
import {TimeTableSlots} from "../../../model/consts/timeTableSlots";
import {Badge, BadgeProps} from "antd";

interface ListDataItem {
    type: string,
    content: string
}


interface HoursCellTemplateProps {
    listData: Record<string, ListDataItem[]>,
    value: Dayjs,
    clickCell: (value: Dayjs, time) => void
}

const slots = Object.entries(TimeTableSlots);
export const HoursCellTemplate: React.FC<HoursCellTemplateProps> = memo((props: HoursCellTemplateProps) => {
    const {clickCell, value, listData} = props

    const handleClickHours = useCallback((timeKey: string) => (evt: React.MouseEvent) => {
        evt?.stopPropagation();
        clickCell(value, timeKey)
    }, [clickCell, value])
    
    return (
        <div className={classNames('custom-call')}>
            <ul className="call-time-list">
                {
                    slots.map(([key, slot]) => (
                            <li
                                key={`custom_call_${listData[key]}_${slot.view}`}
                                onClick={handleClickHours(key)}
                                style={{ cursor: listData[key]?.length > 0 ? 'pointer' : 'default' }}
                            >
                                {slot.view} {
                                listData[key]?.map((item) => (
                                    <Badge
                                        key={`${item.content}__${item.type}`}
                                        status={item.type as BadgeProps['status']}
                                        text={item.content}
                                        style={{pointerEvents: "none", fontSize: '12px'}}
                                    />
                                ))
                            }
                            </li>
                        )
                    )
                }
            </ul>
        </div>
    )
});
